import React from 'react'

export const ClientLogin = React.lazy(() => import('./client-login'))
export const UserLogin = React.lazy(() => import('./user-login'))
